import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const CountdownTimer = () => {
  // Calculate time until September 30th 10PM IST 2025
  const getTimeUntilDeadline = () => {
    // Create deadline in IST (UTC+5:30) for 2025
    const deadline = new Date('2025-09-30T22:00:00+05:30');
    const now = new Date();
    const timeLeft = deadline.getTime() - now.getTime();
    
    if (timeLeft <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    
    return { days, hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(getTimeUntilDeadline());
  const [seatsLeft] = useState(7);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeUntilDeadline());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-red-600 bg-opacity-90 backdrop-blur-lg rounded-2xl p-6 sm:p-8 text-center border border-red-400 shadow-2xl"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            ⏰ Hurry! Offer Ends 30th Sept 2025 @ 10PM IST
          </h2>
          <p className="text-lg sm:text-xl text-yellow-300 mb-6">
            Only First 15 Tamil Business Owners Eligible
          </p>
          
          <div className="flex justify-center items-center space-x-2 sm:space-x-4 mb-6 flex-wrap">
            {timeLeft.days > 0 && (
              <>
                <div className="text-center mb-2 sm:mb-0">
                  <div className="bg-black bg-opacity-50 rounded-lg p-2 sm:p-3 border border-red-400">
                    <span className="text-2xl sm:text-3xl md:text-4xl font-mono font-bold text-green-400">
                      {timeLeft.days.toString().padStart(2, '0')}
                    </span>
                    <p className="text-xs sm:text-sm text-white mt-1">Days</p>
                  </div>
                </div>
                <span className="text-xl sm:text-2xl text-white font-bold">:</span>
              </>
            )}
            
            <div className="text-center mb-2 sm:mb-0">
              <div className="bg-black bg-opacity-50 rounded-lg p-2 sm:p-3 border border-red-400">
                <span className="text-2xl sm:text-3xl md:text-4xl font-mono font-bold text-green-400">
                  {timeLeft.hours.toString().padStart(2, '0')}
                </span>
                <p className="text-xs sm:text-sm text-white mt-1">Hours</p>
              </div>
            </div>
            
            <span className="text-xl sm:text-2xl text-white font-bold">:</span>
            
            <div className="text-center mb-2 sm:mb-0">
              <div className="bg-black bg-opacity-50 rounded-lg p-2 sm:p-3 border border-red-400">
                <span className="text-2xl sm:text-3xl md:text-4xl font-mono font-bold text-green-400">
                  {timeLeft.minutes.toString().padStart(2, '0')}
                </span>
                <p className="text-xs sm:text-sm text-white mt-1">Minutes</p>
              </div>
            </div>
            
            <span className="text-xl sm:text-2xl text-white font-bold">:</span>
            
            <div className="text-center mb-2 sm:mb-0">
              <div className="bg-black bg-opacity-50 rounded-lg p-2 sm:p-3 border border-red-400">
                <motion.span 
                  className="text-2xl sm:text-3xl md:text-4xl font-mono font-bold text-green-400"
                  animate={{ scale: [1, 1.1, 1] }}
                  transition={{ duration: 1, repeat: Infinity }}
                >
                  {timeLeft.seconds.toString().padStart(2, '0')}
                </motion.span>
                <p className="text-xs sm:text-sm text-white mt-1">Seconds</p>
              </div>
            </div>
          </div>
          
          <div className="mb-4">
            <p className="text-xl sm:text-2xl font-bold text-yellow-300 mb-2">
              🔥 Seats Left: {seatsLeft} / 15
            </p>
            <div className="w-full bg-gray-700 rounded-full h-4">
              <motion.div 
                className="bg-gradient-to-r from-green-500 to-yellow-500 h-4 rounded-full"
                initial={{ width: "100%" }}
                animate={{ width: `${(seatsLeft / 15) * 100}%` }}
                transition={{ duration: 1 }}
              />
            </div>
          </div>

          <div className="text-sm text-gray-300 mt-2">
            <p>⏰ Timer shows Indian Standard Time (IST) - Deadline: Sept 30, 2025</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CountdownTimer;